// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__D99e8","centeredContent":"styles_centeredContent__1mkiN"};